import { AbstractFormArgument } from '@/models/global'
class FormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.type = 6
    this.content = ''
    this.platform = 2
  }
}

export {
  FormArgument
}



// WEBPACK FOOTER //
// ./src/models/client/message.js